var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { padding: "0 20px" } },
    [
      _c(
        "a-row",
        {
          staticClass: "row-box",
          staticStyle: { "margin-top": "20px" },
          attrs: { gutter: 24 },
        },
        [
          _vm._l(_vm.stuCardList, function (item, index) {
            return [
              _c(
                "a-col",
                {
                  staticClass: "flex-between title-margin",
                  attrs: { span: 24 },
                },
                [
                  _c(
                    "div",
                    [
                      index == 0
                        ? _c(
                            "a-radio-group",
                            {
                              staticStyle: { "margin-left": "auto" },
                              on: { change: _vm.changModeType },
                              model: {
                                value: _vm.modeType,
                                callback: function ($$v) {
                                  _vm.modeType = $$v
                                },
                                expression: "modeType",
                              },
                            },
                            [
                              _c("a-radio-button", { attrs: { value: "1" } }, [
                                _vm._v("工作预览"),
                              ]),
                              _c("a-radio-button", { attrs: { value: "2" } }, [
                                _vm._v("整体数据概览"),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    [
                      _c("j-dict-select-tag", {
                        staticStyle: { width: "160px" },
                        attrs: {
                          placeholder: "请选择学年",
                          dictCode: "academic_year_scope",
                          isShowEmpty: false,
                        },
                        on: { select: _vm.selectSchoolYear },
                        model: {
                          value: _vm.queryParam.schoolYear,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryParam, "schoolYear", $$v)
                          },
                          expression: "queryParam.schoolYear",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _vm._l(item.list, function (sItem, sIndex) {
                return _c(
                  "a-col",
                  {
                    key: sIndex,
                    staticStyle: { "margin-bottom": "20px" },
                    attrs: { span: 6 },
                  },
                  [
                    _c(
                      "a-card",
                      {
                        staticClass: "key-point-item",
                        style: { backgroundColor: sItem.backgroundColor },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "title-1", style: { color: "#fff" } },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(sItem.label) +
                                "\n          "
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          { style: { marginTop: "20px", color: "#fff" } },
                          [
                            _c(
                              "span",
                              { staticClass: "number-value" },
                              [
                                _c("CountAnimation", {
                                  attrs: { "end-val": sItem.value },
                                }),
                              ],
                              1
                            ),
                            _vm._v(
                              "\n            " +
                                _vm._s(sIndex > 0 ? "次" : "人") +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ],
                  1
                )
              }),
            ]
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }